import { Component } from '@angular/core';

/**
 * @title Basic use of `<table mat-table>`
 */

@Component({
  selector: 'app-userrole-manage',
  templateUrl: './userrole.manage.component.html'
})
export class UserRoleManageComponent {
  
}